(function () {
  "use strict";

  angular.module("sempraWebapp").component("savingsPackages", {
    templateUrl: "app/pricing/savingsPackages/savingsPackages.component.html",
    controller: savingsPackagesController,
    bindings: {
      savingsPackageData: "<",
      regionCurrency: "<",
      defaultValidityDays: "<",
      onCreate: "&"
    },
    controllerAs: "vm"
  });

  function savingsPackagesController(pricingActions, $translate, $scope) {
    var vm = this;

    $scope.saveButtonClass = "md-primary";

    vm.savingsPackagesData = {};
    vm.savingsPackageList = [];
    vm.editSavingsPackages = false;
    vm.deleteSavingsPackages = false;
    vm.buttonTitle = $translate.instant("SAVE");

    vm.$onChanges = function (changes) {
      if (changes.savingsPackageData) {
        vm.savingsPackageList = changes.savingsPackageData.currentValue;
      }
      if (changes.regionCurrency) {
        vm.regionCurrency = changes.regionCurrency.currentValue;
      }
      if (changes.defaultValidityDays && changes.defaultValidityDays.currentValue) {
        vm.defaultValidityDays = changes.defaultValidityDays.currentValue;
        if (!vm.editSavingsPackages && !vm.deleteSavingsPackages && !vm.savingsPackagesData.validity) {
          vm.savingsPackagesData.validity = vm.defaultValidityDays;
        }
      }
    };

    vm.save = function (savingsPackageData) {
      var data = {
        id: savingsPackageData.id,
        name: savingsPackageData.name,
        creditAmount: savingsPackageData.creditAmount,
        priceAmount: savingsPackageData.priceAmount,
        validity: savingsPackageData.validity
      };
      if (vm.editSavingsPackages) {
        updateSavingsPackageData(data);
      } else if (vm.deleteSavingsPackages) {
        deleteSavingsPackageData(data);
      } else {
        saveSavingsPackageData(data);
      }
    };

    vm.editPackage = function (savingsPackage) {
      vm.savingsPackagesData = {
        id: savingsPackage.id,
        name: savingsPackage.name,
        creditAmount: savingsPackage.credit.amount,
        priceAmount: savingsPackage.price.amount,
        validity: savingsPackage.validity
      };
      vm.buttonTitle = $translate.instant("UPDATE");
      vm.editSavingsPackages = true;
    };

    vm.deletePackage = function (savingsPackage) {
      $scope.saveButtonClass = "custom-save-button-class";
      vm.savingsPackagesData = {
        id: savingsPackage.id,
        name: savingsPackage.name,
        creditAmount: savingsPackage.credit.amount,
        priceAmount: savingsPackage.price.amount,
        validity: savingsPackage.validity
      };
      vm.buttonTitle = $translate.instant("DELETE");
      vm.editSavingsPackages = false;
      vm.deleteSavingsPackages = true;
    };

    vm.cancel = function () {
      vm.savingsPackagesData = {
        id: null,
        name: null,
        creditAmount: null,
        priceAmount: null,
        validity: vm.defaultValidityDays || null
      };
      vm.buttonTitle = $translate.instant("SAVE");
      vm.editSavingsPackages = false;
      vm.deleteSavingsPackages = false;
      $scope.savingsPackageForm.$setUntouched();
      $scope.saveButtonClass = "md-primary";
    };

    function saveSavingsPackageData(data) {
      pricingActions.createCompanySavingsPackage(data).then(function () {
        vm.onCreate();
        vm.cancel();
      });
    }

    function updateSavingsPackageData(data) {
      pricingActions.updateCompanySavingsPackage(data).then(function () {
        vm.onCreate();
        vm.cancel();
      });
    }

    function deleteSavingsPackageData(data) {
      pricingActions.deleteCompanySavingsPackage(data.id).then(function () {
        vm.onCreate();
        vm.cancel();
      });
    }
  }
})();
